__turbopack_context__.v({
  "attributes": "GjrnEq_attributes",
  "card": "GjrnEq_card",
  "image": "GjrnEq_image",
  "isPortrait": "GjrnEq_isPortrait",
});
